import * as Actions from 'reducks/brand/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const BrandReducer = (state = initialState.brand, action: any) => {
  switch (action.type) {
    case Actions.CONFIRM_BRAND:
      return {
        ...state,
        confirm: { ...action.payload },
      }
    case Actions.FETCH_BRANDS:
      return {
        ...state,
        brands: [...action.payload],
      }
    case Actions.INIT_BRAND:
      return { ...initialState.brand }
    default:
      return state
  }
}
